<script lang="ts" setup>
import type { ComponentElementsLinkWrapper } from '@autobid/strapi-integration/graphql/graphql'
import type { Component } from 'vue'
import Notifications from '@autobid/ui/components/layout/header/partials/notifications/Index.vue'
import Login from '@autobid/ui/components/layout/header/partials/WrapperLogin.vue'
import Logout from '@autobid/ui/components/layout/header/partials/WrapperLogout.vue'

interface Props {
  data: ComponentElementsLinkWrapper
}

defineProps<Props>()

const COMPONENTS: Record<ComponentElementsLinkWrapper['wrapper'], Component> = {
  Login,
  Logout,
  Notifications,
}
</script>

<template>
  <component :is="COMPONENTS[data.wrapper]" :data="data" />
</template>
